__turbopack_context__.v({
  "ctaWrapper": "irrVkW_ctaWrapper",
  "description": "irrVkW_description",
  "desktopImage": "irrVkW_desktopImage",
  "eyebrow": "irrVkW_eyebrow",
  "headline": "irrVkW_headline",
  "mobileImage": "irrVkW_mobileImage",
  "outOfStockCta": "irrVkW_outOfStockCta",
  "productInner": "irrVkW_productInner",
  "productWrapper": "irrVkW_productWrapper",
  "section": "irrVkW_section",
  "textBlock": "irrVkW_textBlock",
});
